import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';

const TypeFileUpload = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <CloudUploadOutlined {...props} ref={ref} />
));

TypeFileUpload.displayName = 'TypeFileUpload';

export default TypeFileUpload;
